import Base from '@/plugins/Base';
import router from '@/plugins/Router'

const module = {
    namespaced: true,
    state: () => ({
        data: {},
        nationalID: null,
        pin: null,
        tab: -1,
        time: null,
        mernis: null
    }),
    getters: {
        getData(state) {
            return state.data
        },
        getStatus(state){
            return state.data && state.data.status ? state.data.status:null;
        },
        getNationalID(state) {
            return state.nationalID
        },
        getPin(state) {
            return state.pin
        },
        getTab(state) {
            return state.tab
        },
        getTime(state) {
            return state.time
        },
        getMernis(state){
            return state.mernis
        }
    },

    mutations: {
        setData(state, data) {
            state.data = data
            Base.LocalStorage.set('fashion_design_app_data', state.data)
        },
        setStatus(state, status) {
            state.data.status = status;
            Base.LocalStorage.set('undergraduate_transfer_data', state.data)
        },
        setNationalID(state, nationalID) {
            state.nationalID = nationalID
            Base.LocalStorage.set('fashion_design_app_id', state.nationalID)
        },
        setPin(state, pin) {
            state.pin = pin
            Base.LocalStorage.set('fashion_design_app_pin', state.pin)
        },
        setTab(state, tab) {
            state.tab = tab
            Base.LocalStorage.set('fashion_design_app_tab', state.tab)
        },
        setTime(state, time) {
            state.time = time
            Base.LocalStorage.set('fashion_design_app_time', state.time)
        },
        clearData(state) {
            state.data = {}
            state.nationalID = null
            state.pin = null
        },
        setMernis(state, mernis){
            state.mernis = mernis
            Base.LocalStorage.set('fashion_design_app_mernis', state.mernis)
        },
        clearMernis(state){
            state.mernis = null
            Base.LocalStorage.set('fashion_design_app_mernis', null)
        }
    },

    actions: {
        initData({commit}) {
            let data = Base.LocalStorage.get('fashion_design_app_data')
            let nationalID = Base.LocalStorage.get('fashion_design_app_id')
            let pin = Base.LocalStorage.get('fashion_design_app_pin')
            let tab = Base.LocalStorage.get('fashion_design_app_tab')
            let time = Base.LocalStorage.get('fashion_design_app_time')
            let mernis = Base.LocalStorage.get('fashion_design_app_mernis')
            if (data && nationalID && pin) {
                commit('setData', data)
                commit('setNationalID', nationalID)
                commit('setPin', pin)
                commit('setTab', tab)
                commit('setTime', time)
                commit('setMernis', mernis)
            }
        },

        isLogin({state}) {

            let data = state.data;
            let nationalID = state.nationalID;
            let pin = state.pin;
            if (!data || !nationalID || !pin) {
                router.push('/fashion/design/application/login')
            }
        },

        isLoginGoIndex({state}) {
            let data = state.data;
            let nationalID = state.nationalID;
            let pin = state.pin;
            if (data && nationalID && pin) {
                router.push('/fashion/design/application/form')
            }
        },

        logout({commit}) {
            commit('clearData')
            Base.LocalStorage.remove('fashion_design_app_data')
            Base.LocalStorage.remove('fashion_design_app_id')
            Base.LocalStorage.remove('fashion_design_app_pin')
            Base.LocalStorage.remove('fashion_design_app_tab')
            Base.LocalStorage.remove('fashion_design_app_time')
            Base.LocalStorage.remove('fashion_design_app_mernis')

            router.push('/fashion/design/application/login')
        }
    }
}

export default module;
